import React, { useContext } from 'react'
import { Box, Button, HStack } from '@chakra-ui/react'
import { renewals } from '@homevest/utils'

import { RentalDetailsContext } from '../RentalDetailsContext'
import RenewRentalModal from './CustomRenewalModal/RenewRentalModal'
import DoNotRenewModal from './DoNotRenewModal'
import CancelPendingRenewalModal from './CancelPendingRenewalModal'

const { PENDING_RENEWAL_STATUSES } = renewals
const CANCELABLE_RENEWAL_STATUSES = [
  renewals.RENEWAL_STATUSES.PENDING_OFFER,
  renewals.RENEWAL_STATUSES.OFFERED,
  renewals.RENEWAL_STATUSES.RENEWAL_OPTION_SELECTED,
  renewals.RENEWAL_STATUSES.PENDING_CUSTOMER_SIGNATURE,
  renewals.RENEWAL_STATUSES.PENDING_INITIAL_OPTION_FEE_PAYMENT,
  renewals.RENEWAL_STATUSES.PENDING_UPANDUP_SIGNATURE
]

type RenewalActionsProps = {
  onLedgerRefresh: () => void
}

const RenewalActions = ({ onLedgerRefresh }: RenewalActionsProps) => {
  const [isRenewalModalOpen, setIsRenewalModalOpen] = React.useState(false)
  const [isCancelRenewalModalOpen, setIsCancelRenewalModalOpen] = React.useState(false)
  const [isDoNotRenewModalOpen, setIsDoNotRenewModalOpen] = React.useState(false)

  let { rentalData, refreshRentalDetails } = useContext(RentalDetailsContext)

  const rentalId = rentalData?.id
  const isDoNotRenewSet = !!rentalData?.do_not_renew_selected_at
  const isDoNotRenewNoticeSent = !!rentalData?.do_not_renew_notice_sent_at

  const renewals = (rentalData?.rahWithRenewal ?? []).map((rah) => rah.renewals).flat()
  const pendingRenewal = renewals.filter((renewal) =>
    (PENDING_RENEWAL_STATUSES as string[]).includes(renewal.status)
  )?.[0]

  const handleRenewalChange = () => {
    refreshRentalDetails()
    onLedgerRefresh()
  }

  if (isDoNotRenewSet || isDoNotRenewNoticeSent) {
    return null
  }

  if (pendingRenewal) {
    if (!CANCELABLE_RENEWAL_STATUSES.includes(pendingRenewal.status as any)) {
      return null
    }
    return (
      <>
        <Button
          size='sm'
          colorScheme='red'
          variant='outline'
          onClick={() => setIsCancelRenewalModalOpen(true)}
        >
          Cancel pending renewal
        </Button>
        <CancelPendingRenewalModal
          pendingRenewalId={pendingRenewal.id}
          isOpen={isCancelRenewalModalOpen}
          close={() => setIsCancelRenewalModalOpen(false)}
          onSuccess={handleRenewalChange}
        />
      </>
    )
  }

  return (
    <Box>
      <HStack spacing={2}>
        <RenewRentalModal
          rentalId={rentalId}
          isOpen={isRenewalModalOpen}
          onSuccess={handleRenewalChange}
          setOpen={setIsRenewalModalOpen}
        />
        <Button
          size='sm'
          colorScheme='teal'
          variant='solid'
          onClick={() => setIsRenewalModalOpen(true)}
        >
          Issue custom renewal
        </Button>
        <DoNotRenewModal
          isOpen={isDoNotRenewModalOpen}
          close={() => setIsDoNotRenewModalOpen(false)}
        />
        <Button size='sm' variant='outline' onClick={() => setIsDoNotRenewModalOpen(true)}>
          Do not renew
        </Button>
      </HStack>
    </Box>
  )
}

export default RenewalActions
